(function () {
  'use strict';

  const SUPABASE_URL = 'https://xoolcbbpnvdylcoorlqg.supabase.co';
  const PUBLISHABLE_KEY = 'sb_publishable_bjOrV5qp2n0PtuVFOSA_6g_3Micws2T';

  function getSession() {
    try {
      const key = Object.keys(localStorage).find(
        (k) => k.includes('sb-') && k.endsWith('-auth-token')
      );

      if (!key) return null;

      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      console.error('[Corevian Admin Assign] Session error:', error);
      return null;
    }
  }

  function getAccessToken() {
    return getSession()?.access_token || null;
  }

  async function rpc(functionName, payload = {}) {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error('No active Corevian University session was found.');
    }

    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/rpc/${functionName}`,
      {
        method: 'POST',
        headers: {
          apikey: PUBLISHABLE_KEY,
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    );

    const text = await response.text();

    let body = null;

    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = text;
    }

    if (!response.ok) {
      throw new Error(
        body?.message ||
        body?.details ||
        body?.error ||
        `Request failed with status ${response.status}`
      );
    }

    return body;
  }

  async function restGet(path) {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error('No active Corevian University session was found.');
    }

    const response = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
      method: 'GET',
      headers: {
        apikey: PUBLISHABLE_KEY,
        Authorization: `Bearer ${accessToken}`
      }
    });

    const text = await response.text();

    let body = null;

    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = text;
    }

    if (!response.ok) {
      throw new Error(
        body?.message ||
        body?.details ||
        body?.error ||
        `Request failed with status ${response.status}`
      );
    }

    return body;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getProfileId(profile) {
    return (
      profile.user_id ||
      profile.id ||
      profile.profile_id ||
      ''
    );
  }

  function getProfileName(profile) {
    if (profile.full_name) return profile.full_name;
    if (profile.display_name) return profile.display_name;
    if (profile.name) return profile.name;

    const combinedName = [
      profile.first_name,
      profile.last_name
    ]
      .filter(Boolean)
      .join(' ')
      .trim();

    if (combinedName) return combinedName;

    if (profile.email) return profile.email;

    return 'Corevian User';
  }

  function isActiveProfile(profile) {
    if (profile.is_active === false) return false;
    if (profile.active === false) return false;
    if (String(profile.status || '').toLowerCase() === 'inactive') {
      return false;
    }

    return true;
  }

  async function resolveVersionId(row) {
    const directId =
      row.document_version_id ||
      row.version_id ||
      row.controlled_document_version_id;

    if (directId) return directId;

    const documentCode = row.document_code;
    const versionNumber = row.version_number;

    if (!documentCode || !versionNumber) {
      throw new Error('Unable to identify this document version.');
    }

    const documents = await restGet(
      `controlled_documents?select=id&document_code=eq.${encodeURIComponent(documentCode)}&limit=1`
    );

    if (!Array.isArray(documents) || !documents.length) {
      throw new Error(`Document ${documentCode} could not be found.`);
    }

    const documentId = documents[0].id;

    const versions = await restGet(
      `controlled_document_versions?select=id&document_id=eq.${encodeURIComponent(documentId)}&version_number=eq.${encodeURIComponent(versionNumber)}&limit=1`
    );

    if (!Array.isArray(versions) || !versions.length) {
      throw new Error(
        `Version ${versionNumber} for ${documentCode} could not be found.`
      );
    }

    return versions[0].id;
  }

  function injectStyles() {
    if (document.getElementById('cvnAdminAssignStyles')) return;

    const style = document.createElement('style');
    style.id = 'cvnAdminAssignStyles';

    style.textContent = `
      #cvnAssignLauncher {
        appearance: none;
        border: 1px solid #536178;
        background: #17243a;
        color: #ffffff;
        font-weight: 700;
        padding: 10px 16px;
        border-radius: 8px;
        cursor: pointer;
        margin-left: 10px;
      }

      #cvnAssignLauncher:hover {
        border-color: #19B5B0;
      }

      #cvnAssignOverlay {
        position: fixed;
        inset: 0;
        z-index: 12400;
        background: rgba(3, 8, 18, .80);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
      }

      #cvnAssignPanel {
        width: min(720px, 96vw);
        max-height: 90vh;
        overflow-y: auto;
        background: #0B1426;
        color: #ffffff;
        border: 1px solid rgba(25,181,176,.35);
        border-radius: 16px;
        padding: 26px;
        box-shadow: 0 24px 70px rgba(0,0,0,.45);
      }

      #cvnAssignPanel h2 {
        margin: 0 0 7px;
        font-size: 25px;
      }

      .cvn-assign-subtitle {
        color: #aab6c9;
        line-height: 1.5;
        margin-bottom: 22px;
      }

      #cvnAssignMessage {
        display: none;
        margin-bottom: 16px;
        padding: 11px 13px;
        border-radius: 8px;
      }

      #cvnAssignMessage.success {
        display: block;
        background: rgba(25,181,176,.14);
        border: 1px solid rgba(25,181,176,.45);
        color: #cffffb;
      }

      #cvnAssignMessage.error {
        display: block;
        background: rgba(190,65,65,.13);
        border: 1px solid rgba(210,80,80,.45);
        color: #ffd2d2;
      }

      .cvn-assign-field {
        margin-bottom: 18px;
      }

      .cvn-assign-field label {
        display: block;
        font-size: 13px;
        font-weight: 700;
        color: #d7e0ec;
        margin-bottom: 7px;
      }

      .cvn-assign-field select,
      .cvn-assign-field input {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #31415a;
        background: #111d31;
        color: #ffffff;
        border-radius: 8px;
        padding: 12px;
        font: inherit;
      }

      .cvn-assign-notice {
        margin: 18px 0 22px;
        padding: 13px 14px;
        border-left: 3px solid #19B5B0;
        background: rgba(25,181,176,.07);
        color: #c7d2df;
        line-height: 1.55;
        font-size: 14px;
      }

      .cvn-assign-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        border-top: 1px solid #26354c;
        padding-top: 20px;
      }

      .cvn-assign-actions button {
        border-radius: 8px;
        padding: 11px 18px;
        font-weight: 700;
        cursor: pointer;
      }

      #cvnAssignCancel {
        background: transparent;
        border: 1px solid #536178;
        color: #ffffff;
      }

      #cvnAssignSubmit {
        background: #19B5B0;
        border: 1px solid #19B5B0;
        color: #07101f;
      }

      #cvnAssignSubmit:disabled {
        opacity: .55;
        cursor: not-allowed;
      }

      .cvn-assign-empty {
        padding: 18px;
        border: 1px solid #31415a;
        border-radius: 9px;
        color: #aab6c9;
      }
    `;

    document.head.appendChild(style);
  }

  function closeModal() {
    document.getElementById('cvnAssignOverlay')?.remove();
  }

  function showMessage(message, type) {
    const el = document.getElementById('cvnAssignMessage');

    if (!el) return;

    el.className = type;
    el.textContent = message;
  }

  async function refreshAdminRegister() {
    const adminOverlay = document.getElementById('cvnAdminDocsOverlay');

    if (!adminOverlay) return;

    const refreshButton = Array.from(
      adminOverlay.querySelectorAll('button')
    ).find(
      (button) => button.textContent.trim() === 'Refresh Register'
    );

    if (refreshButton) {
      setTimeout(() => refreshButton.click(), 300);
    }
  }

  async function loadProfiles() {
    const profiles = await restGet('profiles?select=*');

    if (!Array.isArray(profiles)) {
      throw new Error('The Corevian user directory could not be loaded.');
    }

    return profiles
      .filter(isActiveProfile)
      .filter((profile) => getProfileId(profile))
      .sort((a, b) =>
        getProfileName(a).localeCompare(getProfileName(b))
      );
  }

  async function openAssignModal() {
    if (document.getElementById('cvnAssignOverlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'cvnAssignOverlay';

    overlay.innerHTML = `
      <div id="cvnAssignPanel">
        <h2>Assign Controlled Document</h2>

        <div class="cvn-assign-subtitle">
          Assign an approved controlled-document version to an active
          Corevian University user.
        </div>

        <div id="cvnAssignMessage"></div>

        <div id="cvnAssignContent">
          Loading approved documents and active users...
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    try {
      const [register, profiles] = await Promise.all([
        rpc('get_admin_controlled_document_register', {}),
        loadProfiles()
      ]);

      if (!Array.isArray(register)) {
        throw new Error(
          'The controlled-document register could not be loaded.'
        );
      }

      const approved = register.filter(
        (row) =>
          String(row.version_status || '').toLowerCase() === 'approved'
      );

      const content = document.getElementById('cvnAssignContent');

      if (!approved.length) {
        content.innerHTML = `
          <div class="cvn-assign-empty">
            No approved controlled-document versions are available
            for assignment.
          </div>

          <div class="cvn-assign-actions">
            <button id="cvnAssignCancel" type="button">Close</button>
          </div>
        `;

        document
          .getElementById('cvnAssignCancel')
          .addEventListener('click', closeModal);

        return;
      }

      if (!profiles.length) {
        content.innerHTML = `
          <div class="cvn-assign-empty">
            No active Corevian University users are available
            for assignment.
          </div>

          <div class="cvn-assign-actions">
            <button id="cvnAssignCancel" type="button">Close</button>
          </div>
        `;

        document
          .getElementById('cvnAssignCancel')
          .addEventListener('click', closeModal);

        return;
      }

      const documentOptions = approved
        .map((row, index) => {
          const code = escapeHtml(row.document_code);
          const title = escapeHtml(row.title);
          const version = escapeHtml(row.version_number);

          return `
            <option value="${index}">
              ${code} — ${title} — Version ${version}
            </option>
          `;
        })
        .join('');

      const userOptions = profiles
        .map((profile, index) => {
          const name = escapeHtml(getProfileName(profile));
          const role = escapeHtml(profile.role || 'user');

          return `
            <option value="${index}">
              ${name} — ${role}
            </option>
          `;
        })
        .join('');

      content.innerHTML = `
        <div class="cvn-assign-field">
          <label for="cvnAssignDocument">
            Approved Document Version *
          </label>

          <select id="cvnAssignDocument">
            ${documentOptions}
          </select>
        </div>

        <div class="cvn-assign-field">
          <label for="cvnAssignUser">
            Assign To *
          </label>

          <select id="cvnAssignUser">
            ${userOptions}
          </select>
        </div>

        <div class="cvn-assign-field">
          <label for="cvnAssignDueDate">
            Due Date and Time — Optional
          </label>

          <input
            id="cvnAssignDueDate"
            type="datetime-local"
          >
        </div>

        <div class="cvn-assign-notice">
          The assignment will reference this exact approved document
          version. Future revisions will remain separate controlled
          versions and can be assigned independently.
        </div>

        <div class="cvn-assign-actions">
          <button id="cvnAssignCancel" type="button">
            Cancel
          </button>

          <button id="cvnAssignSubmit" type="button">
            Assign Document
          </button>
        </div>
      `;

      document
        .getElementById('cvnAssignCancel')
        .addEventListener('click', closeModal);

      document
        .getElementById('cvnAssignSubmit')
        .addEventListener('click', async function () {
          const button = this;

          const documentIndex = Number(
            document.getElementById('cvnAssignDocument').value
          );

          const userIndex = Number(
            document.getElementById('cvnAssignUser').value
          );

          const selectedDocument = approved[documentIndex];
          const selectedProfile = profiles[userIndex];

          if (!selectedDocument) {
            showMessage(
              'Please select a valid approved document version.',
              'error'
            );
            return;
          }

          if (!selectedProfile) {
            showMessage(
              'Please select a valid active Corevian University user.',
              'error'
            );
            return;
          }

          const userId = getProfileId(selectedProfile);

          if (!userId) {
            showMessage(
              'The selected user does not have a valid user ID.',
              'error'
            );
            return;
          }

          const dueDateValue =
            document.getElementById('cvnAssignDueDate').value;

          let dueAt = null;

          if (dueDateValue) {
            const dueDate = new Date(dueDateValue);

            if (Number.isNaN(dueDate.getTime())) {
              showMessage(
                'Please enter a valid due date and time.',
                'error'
              );
              return;
            }

            dueAt = dueDate.toISOString();
          }

          const code = selectedDocument.document_code;
          const version = selectedDocument.version_number;
          const userName = getProfileName(selectedProfile);

          button.disabled = true;
          button.textContent = 'Assigning...';

          try {
            const documentVersionId =
              await resolveVersionId(selectedDocument);

            const result = await rpc(
              'assign_controlled_document_to_user',
              {
                p_user_id: userId,
                p_document_version_id: documentVersionId,
                p_due_at: dueAt
              }
            );

            console.log(
              '[Corevian Admin Assign] Assignment created:',
              result
            );

            showMessage(
              `${code} Version ${version} was assigned successfully to ${userName}.`,
              'success'
            );

            await refreshAdminRegister();

            setTimeout(closeModal, 1500);

          } catch (error) {
            console.error(
              '[Corevian Admin Assign] Assignment failed:',
              error
            );

            showMessage(
              error.message || 'Unable to assign controlled document.',
              'error'
            );

            button.disabled = false;
            button.textContent = 'Assign Document';
          }
        });

    } catch (error) {
      console.error(
        '[Corevian Admin Assign] Unable to load assignment data:',
        error
      );

      const content = document.getElementById('cvnAssignContent');

      content.innerHTML = `
        <div class="cvn-assign-empty">
          Unable to load assignment data.
        </div>

        <div class="cvn-assign-actions">
          <button id="cvnAssignCancel" type="button">
            Close
          </button>
        </div>
      `;

      showMessage(error.message, 'error');

      document
        .getElementById('cvnAssignCancel')
        .addEventListener('click', closeModal);
    }
  }

  function installLauncher() {
    const adminOverlay = document.getElementById('cvnAdminDocsOverlay');

    if (!adminOverlay) return false;

    if (document.getElementById('cvnAssignLauncher')) {
      return true;
    }

    const revisionButton =
      document.getElementById('cvnRevisionLauncher');

    const approveButton =
      document.getElementById('cvnApproveLauncher');

    const reviewButton =
      document.getElementById('cvnSubmitReviewLauncher');

    const createButton =
      document.getElementById('cvnCreateDraftBtn');

    const refreshButton = Array.from(
      adminOverlay.querySelectorAll('button')
    ).find(
      (button) => button.textContent.trim() === 'Refresh Register'
    );

    const anchor =
      revisionButton ||
      approveButton ||
      reviewButton ||
      createButton ||
      refreshButton;

    if (!anchor) return false;

    const button = document.createElement('button');

    button.id = 'cvnAssignLauncher';
    button.type = 'button';
    button.textContent = 'Assign Document';

    anchor.insertAdjacentElement('afterend', button);

    button.addEventListener('click', openAssignModal);

    return true;
  }

  function start() {
    injectStyles();
    installLauncher();

    const observer = new MutationObserver(function () {
      installLauncher();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();